/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Verify_DoneInputs */

const cs_portals_verify_done = /** @type {(inputs: Portals_Verify_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikace ověřena`)
};

const en_portals_verify_done = /** @type {(inputs: Portals_Verify_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication verified`)
};

/**
* | output |
* | --- |
* | "Publication verified" |
*
* @param {Portals_Verify_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_verify_done = /** @type {((inputs?: Portals_Verify_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Verify_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_verify_done(inputs)
	return cs_portals_verify_done(inputs)
});